/*!
* phone-codes/phone-nl.js
* https://github.com/RobinHerbots/Inputmask
* Copyright (c) 2010 - 2017 Robin Herbots
* Licensed under the MIT license (http://www.opensource.org/licenses/mit-license.php)
* Version: 3.3.5
*/

!function(factory) {
    "function" == typeof define && define.amd ? define([ "../inputmask" ], factory) : "object" == typeof exports ? module.exports = factory(require("../inputmask")) : factory(window.Inputmask);
}(function(Inputmask) {
    return Inputmask.extendAliases({
        phonenl: {
            alias: "abstractphone",
            countrycode: "31",
            phoneCodes: [ {
                mask: "+31-10-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Rotterdam"
            }, {
                mask: "+31-111-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Zierikzee"
            }, {
                mask: "+31-113-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Goes"
            }, {
                mask: "+31-114-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Hulst"
            }, {
                mask: "+31-115-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Terneuzen"
            }, {
                mask: "+31-117-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Oostburg"
            }, {
                mask: "+31-118-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Middelburg"
            }, {
                mask: "+31-13-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Tilburg"
            }, {
                mask: "+31-14-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Intern gebruik door KPN"
            }, {
                mask: "+31-15-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Delft"
            }, {
                mask: "+31-161-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Rijen"
            }, {
                mask: "+31-162-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Oosterhout"
            }, {
                mask: "+31-164-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Bergen op Zoom"
            }, {
                mask: "+31-165-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Roosendaal"
            }, {
                mask: "+31-166-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Tholen"
            }, {
                mask: "+31-167-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Steenbergen"
            }, {
                mask: "+31-168-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Zevenbergen"
            }, {
                mask: "+31-172-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Alphen aan den Rijn"
            }, {
                mask: "+31-174-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Naaldwijk"
            }, {
                mask: "+31-180-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Krimpen aan den IJsel"
            }, {
                mask: "+31-181-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Spijkenisse"
            }, {
                mask: "+31-182-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Gouda"
            }, {
                mask: "+31-183-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Gorinchem"
            }, {
                mask: "+31-184-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Sliedrecht"
            }, {
                mask: "+31-186-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Oud-Beijerland"
            }, {
                mask: "+31-187-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Middelharnis"
            }, {
                mask: "+31-20-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Amsterdam"
            }, {
                mask: "+31-222-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Den Burg"
            }, {
                mask: "+31-223-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Den Helder"
            }, {
                mask: "+31-224-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Schagen"
            }, {
                mask: "+31-226-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Noord-Scharwoude"
            }, {
                mask: "+31-227-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Middenmeer"
            }, {
                mask: "+31-228-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Enkhuizen"
            }, {
                mask: "+31-229-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Hoorn"
            }, {
                mask: "+31-23-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Haarlem"
            }, {
                mask: "+31-24-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Nijmegen"
            }, {
                mask: "+31-251-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Beverwijk"
            }, {
                mask: "+31-252-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Hillegom"
            }, {
                mask: "+31-255-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "IJmuiden"
            }, {
                mask: "+31-26-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Arnhem"
            }, {
                mask: "+31-294-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Weesp"
            }, {
                mask: "+31-297-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Uithoorn"
            }, {
                mask: "+31-299-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Purmerend"
            }, {
                mask: "+31-30-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Utrecht"
            }, {
                mask: "+31-313-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Dieren"
            }, {
                mask: "+31-314-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Doetinchem"
            }, {
                mask: "+31-315-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Terborg"
            }, {
                mask: "+31-316-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Zevenaar"
            }, {
                mask: "+31-317-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Wageningen"
            }, {
                mask: "+31-318-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Ede"
            }, {
                mask: "+31-320-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Lelystad"
            }, {
                mask: "+31-321-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Dronten"
            }, {
                mask: "+31-33-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Amersfoort"
            }, {
                mask: "+31-341-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Harderwijk"
            }, {
                mask: "+31-342-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Barneveld"
            }, {
                mask: "+31-343-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Doorn"
            }, {
                mask: "+31-344-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Tiel"
            }, {
                mask: "+31-294-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Weesp"
            }, {
                mask: "+31-297-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Uithoorn"
            }, {
                mask: "+31-299-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Purmerend"
            }, {
                mask: "+31-30-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Utrecht"
            }, {
                mask: "+31-313-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Dieren"
            }, {
                mask: "+31-314-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Doetinchem"
            }, {
                mask: "+31-315-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Terborg"
            }, {
                mask: "+31-316-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Zevenaar"
            }, {
                mask: "+31-317-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Wageningen"
            }, {
                mask: "+31-318-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Ede"
            }, {
                mask: "+31-320-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Lelystad"
            }, {
                mask: "+31-321-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Dronten"
            }, {
                mask: "+31-33-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Amersfoort"
            }, {
                mask: "+31-341-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Harderwijk"
            }, {
                mask: "+31-342-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Barneveld"
            }, {
                mask: "+31-343-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Doorn"
            }, {
                mask: "+31-344-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Tiel"
            }, {
                mask: "+31-345-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Culemborg"
            }, {
                mask: "+31-346-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Maarssen"
            }, {
                mask: "+31-347-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Vianen"
            }, {
                mask: "+31-348-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Woerden"
            }, {
                mask: "+31-35-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Hilversum"
            }, {
                mask: "+31-36-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Almere"
            }, {
                mask: "+31-38-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Zwolle"
            }, {
                mask: "+31-40-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Eindhoven"
            }, {
                mask: "+31-411-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Boxtel"
            }, {
                mask: "+31-412-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Oss"
            }, {
                mask: "+31-413-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Veghel"
            }, {
                mask: "+31-416-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Waalwijk"
            }, {
                mask: "+31-418-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Zaltbommel"
            }, {
                mask: "+31-43-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Maastricht"
            }, {
                mask: "+31-45-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Heerlen"
            }, {
                mask: "+31-46-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Sittard"
            }, {
                mask: "+31-475-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Roermond"
            }, {
                mask: "+31-478-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Venray"
            }, {
                mask: "+31-481-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Bemmel"
            }, {
                mask: "+31-485-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Cuijk"
            }, {
                mask: "+31-486-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Grave"
            }, {
                mask: "+31-487-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Druten"
            }, {
                mask: "+31-488-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Zetten"
            }, {
                mask: "+31-492-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Helmond"
            }, {
                mask: "+31-493-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Deurne"
            }, {
                mask: "+31-495-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Weert"
            }, {
                mask: "+31-497-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Eersel"
            }, {
                mask: "+31-499-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Best"
            }, {
                mask: "+31-50-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Groningen"
            }, {
                mask: "+31-511-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Feanw\ufffdlden"
            }, {
                mask: "+31-512-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Drachten"
            }, {
                mask: "+31-513-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Heerenveen"
            }, {
                mask: "+31-514-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Balk"
            }, {
                mask: "+31-515-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Sneek"
            }, {
                mask: "+31-516-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Oosterwolde"
            }, {
                mask: "+31-517-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Franeker"
            }, {
                mask: "+31-518-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "St Annaparochie"
            }, {
                mask: "+31-519-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Dokkum"
            }, {
                mask: "+31-521-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Steenwijk"
            }, {
                mask: "+31-522-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Meppel"
            }, {
                mask: "+31-523-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Dedemsvaart"
            }, {
                mask: "+31-524-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Coevorden"
            }, {
                mask: "+31-525-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Elburg"
            }, {
                mask: "+31-527-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Emmeloord"
            }, {
                mask: "+31-528-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Hoogeveen"
            }, {
                mask: "+31-529-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Ommen"
            }, {
                mask: "+31-53-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Enschede"
            }, {
                mask: "+31-541-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Oldenzaal"
            }, {
                mask: "+31-543-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Winterswijk"
            }, {
                mask: "+31-544-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Groenlo"
            }, {
                mask: "+31-545-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Neede"
            }, {
                mask: "+31-546-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Almelo"
            }, {
                mask: "+31-547-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Goor"
            }, {
                mask: "+31-548-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Rijssen"
            }, {
                mask: "+31-55-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Apeldoorn"
            }, {
                mask: "+31-561-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Wolvega"
            }, {
                mask: "+31-562-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "West-Terschelling"
            }, {
                mask: "+31-566-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Jirnsum"
            }, {
                mask: "+31-570-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Deventer"
            }, {
                mask: "+31-571-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Twello"
            }, {
                mask: "+31-572-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Raalte"
            }, {
                mask: "+31-573-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Lochem"
            }, {
                mask: "+31-575-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Zutphen"
            }, {
                mask: "+31-577-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Uddel"
            }, {
                mask: "+31-578-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Epe"
            }, {
                mask: "+31-58-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Leeuwarden"
            }, {
                mask: "+31-591-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Emmen"
            }, {
                mask: "+31-592-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Assen"
            }, {
                mask: "+31-593-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Beilen"
            }, {
                mask: "+31-594-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Zuidhorn"
            }, {
                mask: "+31-595-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Warffum"
            }, {
                mask: "+31-596-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Appingedam"
            }, {
                mask: "+31-597-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Winschoten"
            }, {
                mask: "+31-598-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Hoogezand"
            }, {
                mask: "+31-599-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Stadskanaal"
            }, {
                mask: "+31-70-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Den Haag"
            }, {
                mask: "+31-71-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Leiden"
            }, {
                mask: "+31-72-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Alkmaar"
            }, {
                mask: "+31-73-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "'s-Hertogenbosch"
            }, {
                mask: "+31-74-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Hengelo"
            }, {
                mask: "+31-75-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Zaandam"
            }, {
                mask: "+31-76-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Breda"
            }, {
                mask: "+31-77-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Venlo"
            }, {
                mask: "+31-78-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Dordrecht"
            }, {
                mask: "+31-79-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Zoetermeer"
            }, {
                mask: "+31-61-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Mobiele nummers"
            }, {
                mask: "+31-62-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Mobiele nummers"
            }, {
                mask: "+31-63-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Mobiele nummers"
            }, {
                mask: "+31-64-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Mobiele nummers"
            }, {
                mask: "+31-65-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Mobiele nummers"
            }, {
                mask: "+31-68-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Mobiele nummers"
            }, {
                mask: "+31-69-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Mobiele nummers"
            }, {
                mask: "+31-66-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Semafonie"
            }, {
                mask: "+31-670-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Videotex"
            }, {
                mask: "+31-671-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Videotex"
            }, {
                mask: "+31-672-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Videotex"
            }, {
                mask: "+31-673-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Videotex"
            }, {
                mask: "+31-674-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Videotex"
            }, {
                mask: "+31-675-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Videotex"
            }, {
                mask: "+31-676-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Inbelnummers van internetproviders"
            }, {
                mask: "+31-800-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Gratis informatienummers"
            }, {
                mask: "+31-82-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Virtual Private Network"
            }, {
                mask: "+31-88-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Bedrijfsnummers"
            }, {
                mask: "+31-900-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Betaalde informatienummers"
            }, {
                mask: "+31-906-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Betaalde informatienummers"
            }, {
                mask: "+31-909-###-###",
                cc: "NL",
                cd: "Netherlands",
                city: "Betaalde informatienummers"
            }, {
                mask: "+31-91-###-####",
                cc: "NL",
                cd: "Netherlands",
                city: "Plaatsonafhankelijk netnummer, geschikt voor beeldtelefonie of lijnen met verhoogde kwaliteit"
            } ]
        }
    }), Inputmask;
});